module.exports = {"title":"Sold out!","description":"We are sorry to inform you this event date/time is currently Sold Out","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/NoTicketsModal/locales/en.json
// module id = 1338
// module chunks = 0